import type { ResourceState } from '@displaycms/contracts';
import type { BadgeProps } from '@/components/ui/badge';

/**
 * Resource/composer lifecycle state → SP1 semantic Badge variant (replaces the
 * hardcoded per-file tone maps). Shared by the composer + resource list/detail
 * surfaces. Index with a fallback (`?? 'neutral'`) at call sites for safety.
 */
export const STATE_BADGE_VARIANT: Record<
  ResourceState,
  NonNullable<BadgeProps['variant']>
> = {
  draft: 'neutral',
  pending_review: 'warning',
  recommended: 'info',
  approved: 'success',
  revoked: 'danger',
  expired: 'neutral',
};
